var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-map" }, [
    _vm.detail ? _c("div", { ref: "map", staticClass: "map" }) : _vm._e(),
    _vm._v(" "),
    _vm.detail
      ? _c(
          "div",
          { staticClass: "map-guide", on: { click: _vm.openTecentMap } },
          [_vm._v("导航")]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }